import { Directive, computed, inject, input } from '@angular/core';

import { finalize } from 'rxjs/operators';

import { isOsVersionAtLeast } from '@rocksoft/shared';
import { AppleMdmService } from '../../../../shared/services/apple-mdm-service';
import { AppleDevice } from '../../../../viewmodels/apple/apple-device.model';

@Directive()
export class RestartDeviceBaseDirective {
  private readonly appleMdmService = inject(AppleMdmService);

  readonly apple = input.required<AppleDevice>();
  readonly class = input.required<string>();
  isWorking = true;
  readonly isSupervised = computed(() => {
    return this.apple()?.isSupervised ?? false;
  });
  readonly hasSupportedOS = computed(() => isOsVersionAtLeast(this.apple().osVersion, '10.3.0'));

  get isEnabled(): boolean | null {
    return this.isSupervised() && this.isWorking && (this.hasSupportedOS() == null || this.hasSupportedOS());
  }

  restart() {
    const udid = this.apple().udid;
    if (!this.isEnabled) {
      return;
    }
    this.isWorking = false;
    this.appleMdmService
      .restartDevice(udid)
      .pipe(
        finalize(() => {
          this.isWorking = true;
        })
      )
      .subscribe();
  }
}
